import { SpriteIcon } from "@shared/ui/SpriteIcon";
import { SlideInstruction } from "./types";
import classes from "./show-instruction.module.scss";

export const SLIDES_INSTRUCTION: SlideInstruction[] = [
    {
        title: "Описание компании",
        content: (
            <>
                позволяет презентовать вашу компанию с помощью картинок и внешних ссылок, делая
                акцент на ключевых преимуществах. Это удобный способ рассказать о бизнесе ярко и
                наглядно.
            </>
        ),
        tag: "Описание"
    },
    {
        title: "Выделите фрагмент текста, чтобы изменить его внешний вид или добавить ссылку",
        sample: (
            <div className={classes["show-instruction__toolbar"]}>
                <SpriteIcon
                    className={classes["show-instruction__toolbar--item"]}
                    section={"editor"}
                    name={"heading_h2"}
                />
                <SpriteIcon
                    className={classes["show-instruction__toolbar--item"]}
                    section={"editor"}
                    name={"heading_h3"}
                />
                <SpriteIcon
                    className={classes["show-instruction__toolbar--item"]}
                    section={"editor"}
                    name={"ul"}
                />
                <SpriteIcon
                    className={classes["show-instruction__toolbar--item"]}
                    section={"editor"}
                    name={"ol"}
                />
                <SpriteIcon
                    className={classes["show-instruction__toolbar--item"]}
                    section={"editor"}
                    name={"bold"}
                />
                <SpriteIcon
                    className={classes["show-instruction__toolbar--item"]}
                    section={"editor"}
                    name={"italic"}
                />
                <SpriteIcon
                    className={classes["show-instruction__toolbar--item"]}
                    section={"editor"}
                    name={"link"}
                />
            </div>
        ),
        content: (
            <>
                При выборе семейного{" "}
                <span className={classes["show-instruction__text--selection"]}>автомобиля</span>{" "}
                автолюбителю важно учитывать комфорт, безопасность и бюджет
            </>
        ),
        tag: "Текст"
    },
    {
        title: "Добавляйте в статьи изображения, видео, музыку и посты из соцсетей",
        sample: (
            <SpriteIcon
                className={classes["show-instruction__image"]}
                section={"editor"}
                name={"image"}
            />
        ),
        content: (
            <>
                Для вставки изображения используйте для значки, которые появляются в начале новой
                строки.
            </>
        ),
        tag: "Медиа"
    },
    {
        title: "Всё сохраняется автоматически",
        tag: "Сохранение"
    }
];